import React from 'react';
import styled from 'styled-components';
import Message1 from '../../Image/Message1.png';
import Message2 from '../../Image/Message2.png';

const testimonialsData = [
    {
      id: 1,
      name: 'Sofia Potter',
      message:
        'These guys are incredible to work with. Like seriously! They did everything so good, that I did not even imagine it would come up this awesome! Really looking forward to working with them again.',
      image: Message1,
    },
    {
      id: 2,
      name: 'Jordan Browler',
      message:
        'These guys are incredible to work with. Like seriously! They did everything so good, that I did not even imagine it would come up this awesome! Really looking forward to working with them again.',
      image: Message2,
    },
  ];
  
  const Testimonials = () => {
    return (
      <Testimonialsmain>
        <Heading1>Testimonials</Heading1>
        <Messagecard>
          {testimonialsData.map((testimonial) => (
            <MessagecardItem key={testimonial.id}>
              <Image src={testimonial.image} alt={`Message ${testimonial.id}`} />
              <Content>
                <HeadingContent>{testimonial.name}</HeadingContent>
                <ParagraphContent>{testimonial.message}</ParagraphContent>
              </Content>
            </MessagecardItem>
          ))}
        </Messagecard>
      </Testimonialsmain>
    );
  };
  
  export default Testimonials;
  
  const Testimonialsmain = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: 80%;
    margin: auto;
    `;
    
    const Heading1 = styled.div`
    font-family: Poppins;
    font-size: 48px;
    font-weight: 700;
    color: #062126;
    margin-left: 20%;
    margin-top: 5%;
  `;
  
  const Messagecard = styled.div`
    display: flex;
    justify-content: center;
    align-item: center;
    margin-top: 30px;
    flex-wrap: wrap;
    gap: 20px;
    padding: 0 5%;
    `;
    
    const MessagecardItem = styled.div`
    border: 1px solid grey;
    padding: 1% 2%;
    width: 35%;
    height: auto;
    border-radius: 20px;
    background: #cf7d4e0d;
    margin-bottom: 20px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  
    @media (max-width: 930px) {
      width: 90%;
    }
  `;
  
  const Image = styled.img`
    // width: 100%;
    width: 100px;
    height: 100px;
    border-radius: 20px 0 0 20px;
  `;
  
  const Content = styled.div`
    padding: 10px 20px 0 0;
  `;
  
  const HeadingContent = styled.h1`
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
  `;
  
  const ParagraphContent = styled.p`
    font-family: Poppins;
    font-size: 18px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
    color: #062126b2;
  
    @media (max-width: 768px) {
      font-size: 16px;
    }
  `;